/** Semicircle arc length for gauge SVG (radius 45, 180°). */
export const LARGE_ARC_LEN = 141.37;

/** Semicircle arc length for compact gauge SVG (radius 33). */
export const SMALL_ARC_LEN = 103.67;

export function arcDashArray(percent, arcLen = LARGE_ARC_LEN) {
  const p = Math.max(0, Math.min(100, Number(percent) || 0));
  const dash = (p / 100) * arcLen;
  return {
    dash: dash.toFixed(2),
    len: arcLen.toFixed(2),
  };
}

export function defectLimitMarker(arcLen = SMALL_ARC_LEN, limitPct = 100) {
  const p = Math.max(0, Math.min(100, Number(limitPct) || 0));
  const angle = Math.PI - (p / 100) * Math.PI;
  const cx = 41;
  const cy = 41;
  const r = 33;
  return {
    x: (cx + r * Math.cos(angle)).toFixed(2),
    y: (cy + r * Math.sin(angle)).toFixed(2),
  };
}
